// useUpdateOrderStatusMutation.js
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { removeResolution } from "api/repair-orders";

const useRemoveResolution = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(removeResolution, {
    onMutate: async ({ repairOrderId }) => {
      // Cancel any outgoing refetches
      await queryClient.cancelQueries({
        queryKey: ["repairOrder", repairOrderId],
      });
      // Snapshot the previous data
      const previousOrder = queryClient.getQueryData([
        "repairOrder",
        repairOrderId,
      ]);

      if (!previousOrder) {
        console.error("No previous order found");
        console.log("repairOrderId", repairOrderId);
        return;
      }

      // Optimistically update the repair order with the new comment
      queryClient.setQueryData(["repairOrder", repairOrderId], (old) => ({
        ...old,
        updatedAt: dayjs().toISOString(),
        resolutionTypeId: null,
        resolutionType: null,
        resolutionAt: null,
        repairOrderStatus: { id: 1, name: "In Queue" },
        repairOrderStatusId: 1,
      }));

      // Return context with the previous order for rollback
      return { previousOrder };
    },
    onError: (error, variables, context) => {
      if (context?.previousOrder) {
        queryClient.setQueryData(
          ["repairOrder", variables.repairOrderId],
          context.previousOrder
        );
      }
      console.error(
        error?.response?.data?.message || "Error removing resolution"
      );
      enqueueSnackbar("Failed to add payment", { variant: "error" });
    },
    onSuccess: (data, variables) => {
      enqueueSnackbar("Resolution removed successfully", {
        variant: "success",
      });
    },
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries(["repairOrder", variables.repairOrderId]);
    },
  });
};

export default useRemoveResolution;
